import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { BlocklistFilterSource } from 'garaje/utils/enums';

function getStatus(report = []) {
  if (report.every((r) => r.status === 'approved')) {
    return 'approved';
  }
  if (report.any((r) => r.status === 'denied')) {
    return 'denied';
  }
  return 'review';
}

function setFlowOnEntry(entry, flow) {
  const userData = entry.userData ?? [];
  if (!entry._noPov) {
    let purposeOfVisit = userData.find((datum) => datum.field === 'Purpose of visit');
    if (purposeOfVisit) {
      purposeOfVisit.value = flow.name;
    } else {
      purposeOfVisit = { field: 'Purpose of visit', value: flow.name };
      userData.push(purposeOfVisit);
    }
  }

  entry.update({
    flow,
    flowName: flow.name,
    userData,
  });
}

export default Factory.extend({
  fullName: () => faker.person.fullName(),
  signedInAt: () => new Date(),
  signedOutAt: null,
  userData() {
    return [
      { field: 'emailAddress', value: faker.internet.email() },
      { field: 'Purpose of visit', value: 'Interview' },
    ];
  },
  additionalGuests: null,
  idCheckStatus: null,
  locationNames() {
    return [this.location?.name];
  },

  /*
   * approval status for block list
   *
   * @return {Object} entry results against a block list
   *   status [review|pending|approved|denied]
   */
  approvalStatus() {
    return { report: undefined, status: undefined };
  },
  flowName() {
    return this.flow?.name ?? 'Interview';
  },

  afterCreate(entry, server) {
    if (entry.flow || entry._noFlow) return;
    // assign corresponding flow to entry
    const flow = server.schema.flows.findOrCreateBy({ name: entry.flowName });
    setFlowOnEntry(entry, flow);
  },

  delivery: trait({
    flowName: 'Delivery',
    userData() {
      return [
        { field: 'emailAddress', value: faker.internet.email() },
        { field: 'Purpose of visit', value: 'Delivery' },
      ];
    },
  }),

  withSignInUser: trait({
    afterCreate(entry, server) {
      entry.update({
        signInUser: server.create('user'),
      });
    },
  }),

  asLocationBlocklistFailed: trait({
    afterCreate(entry, server) {
      const blocklistFilter = server.create('blacklist-filter', {
        createdBy: 'test admin',
        fullName: entry.fullName,
        reason: 'BOLO',
      });

      const report = [
        ...(entry.approvalStatus?.report || []),
        {
          source: 'blacklist',
          result: 'fail',
          blacklistFilterId: blocklistFilter.id,
          blacklistFilterSource: BlocklistFilterSource.LOCATION,
          blacklistFilterSourceId: null, // todo - id of blocklistFilter.property
          status: 'review',
        },
      ];

      entry.update({
        approvalStatus: {
          status: getStatus(report),
          report,
        },
      });
    },
  }),
});
